import React, { useEffect, useRef } from 'react';
import '../../styles/Reviews.scss';

const reviews = [
  {
    name: "Priya Mehta",
    role: "Health Enthusiast",
    rating: 5,
    product: "Raw Honey 500g",
    verified: true,
    content: "This is the most pure and authentic honey I've ever tasted! The natural sweetness and golden texture is absolutely divine. I use it every morning in my tea and it has become a staple in my kitchen. Highly recommended for anyone looking for genuine, chemical-free honey."
  },
  {
    name: "Rajesh Kumar",
    role: "Fitness Trainer",
    rating: 5,
    product: "Organic Wildflower Honey",
    verified: true,
    content: "As a fitness professional, I always recommend natural honey to my clients, and this brand exceeds all expectations. The taste is rich and authentic, you can tell it's 100% pure. Perfect for post-workout energy boost and natural sweetness without guilt."
  },
  {
    name: "Ananya Singh",
    role: "Mother of Two",
    rating: 5,
    product: "Himalayan Honey 1kg",
    verified: true,
    content: "My kids absolutely love this honey! I feel confident giving it to them knowing it's completely natural and pure. We use it in everything - from pancakes to warm milk. The quality is outstanding and the packaging keeps it fresh. Worth every penny!"
  },
  {
    name: "Dr. Amit Sharma",
    role: "Ayurvedic Practitioner",
    rating: 5,
    product: "Raw Forest Honey",
    verified: true,
    content: "I prescribe honey in many of my treatments, and this is the only brand I trust and recommend to my patients. The purity and medicinal properties are evident. Excellent for immunity and overall wellness. A true gift from nature!"
  },
  {
    name: "Neha Kapoor",
    role: "Home Baker",
    rating: 5,
    product: "Acacia Honey",
    verified: true,
    content: "Perfect for baking! The consistency is ideal and it doesn't crystallize quickly. My cakes and desserts have never tasted better. The mild, sweet flavor enhances everything I make. This honey has transformed my baking!"
  },
  {
    name: "Vikram Patel",
    role: "Tea Connoisseur",
    rating: 5,
    product: "Wild Honey 750g",
    verified: true,
    content: "Being a tea lover, I'm very particular about what I add to my brew. This honey is exceptional - it dissolves perfectly and the natural aroma is heavenly. No artificial taste at all. Pure bliss in every spoonful!"
  }
];

const Reviews = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      const scrollWidth = scrollContainer.scrollWidth;
      const animationDuration = scrollWidth / 50; // Adjust speed here (higher = slower)

      scrollContainer.style.setProperty('--animation-duration', `${animationDuration}s`);
    }
  }, []);

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <svg
        key={index}
        className={`star ${index < rating ? 'filled' : ''}`}
        viewBox="0 0 24 24"
        fill={index < rating ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ));
  };

  return (
    <div className="reviews-container">
      <div className="reviews-header">
        <h2 className="reviews-title">What Our Customers Say</h2>
        <p className="reviews-subtitle">Real experiences from real honey lovers</p>
      </div>
      <div className="reviews-scroll" ref={scrollRef}>
        <div className="reviews-track">
          {[...reviews, ...reviews].map((review, index) => (
            <div key={index} className="review-card">
              <div className="review-header">
                <div className="review-rating">
                  {renderStars(review.rating)}
                </div>
                {review.verified && (
                  <span className="verified-badge">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                    Verified Purchase
                  </span>
                )}
              </div>
              <div className="review-content">
                <p>{review.content}</p>
              </div>
              <div className="review-product">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-9h10v2H7z"/>
                </svg>
                <span>{review.product}</span>
              </div>
              <div className="review-footer">
                <div className="review-avatar">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                </div>
                <div className="review-info">
                  <span className="review-name">{review.name}</span>
                  <span className="review-role">{review.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Reviews;